import PageSEO from '@/components/feature/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedGames from './components/FeaturedGames';
import WhyChooseUs from './components/WhyChooseUs';
import LatestNews from './components/LatestNews';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'galagame',
  url: 'https://www.galagame.com',
  description: 'galagame 是你不容错过的游戏平台，提供丰富的游戏内容、极致的游戏体验与高额奖励。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-000-0000',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="galagame - 官方游戏平台 | 立即体验极致游戏乐趣与高额奖励"
        description="galagame 是你不容错过的游戏平台，提供丰富的游戏内容、极致的游戏体验与高额奖励。立即加入 galagame，探索无限游戏世界，享受专属福利与实时竞技乐趣。"
        keywords="galagame,galagame官网,galagame下载,galagame游戏平台,galagame注册,galagame奖励,galagame最新活动"
        canonicalUrl="https://www.galagame.com/"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGames />
        <WhyChooseUs />
        <LatestNews />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}